export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const PORTAL_LOGIN = AUTH + '/portal-login'

export const COMPANY_LIST = '/company-list'
export const DASHBOARD = '/dashboard'
export const HELP = '/help'

// In-app notifications (served by portal-service, public.notifications scoped to ERPBOI_AMS).
// Reached from the topbar bell's "View all"; not a sidebar menu item.
export const NOTIFICATIONS = '/notifications'

//Accounting
export const ACCOUNTING = '/accounting'
export const COA = ACCOUNTING + '/coa'
export const DEBIT_VOUCHER = ACCOUNTING + '/debit-voucher'
export const CREDIT_VOUCHER = ACCOUNTING + '/credit-voucher'
export const JOURNAL_VOUCHER = ACCOUNTING + '/journal-voucher'

// The three per-type approval features. Their urls stay as permission keys (and as old links,
// which redirect): the screen is the single Pending Approvals list below.
export const DV_APPROVAL = ACCOUNTING + '/dv-approval'
export const CV_APPROVAL = ACCOUNTING + '/cv-approval'
export const JV_APPROVAL = ACCOUNTING + '/jv-approval'

// The Approvals group (as stock's). Neither is an auth.features url:
// Pending Approvals is gated on holding any of the three approval features above, My Requests
// (the vouchers I prepared) on holding any of the three voucher features.
export const PENDING_APPROVALS = ACCOUNTING + '/approvals'
export const MY_REQUESTS = ACCOUNTING + '/my-requests'

// One voucher, read-only, with its Edit / Delete / Approve (2026-10-14). Not an auth.features url:
// open to anyone who can raise or approve a voucher. Every screen that shows a voucher opens it.
export const VOUCHER_VIEW = ACCOUNTING + '/voucher'
export const voucherViewPath = (id: string) => `${VOUCHER_VIEW}/${id}`

export const ACC_RECONCILATION = ACCOUNTING + '/acc-reconciliation'
export const GL_JOURNAL = ACCOUNTING + '/gl-journal'

// Payables (docs/store-gl-procure-to-pay-plan.md): supplier bills against Store's goods receipts.
// SUPPLIER_BILLS and PO_TRACKER are auth.features urls (AMS_F_SUPPLIER_BILL, AMS_F_PO_TRACKER;
// ams-service qa/store_gl_p7_acl.sql). Bills to Enter and the bill's own pages are not: they are
// gated on SUPPLIER_BILLS.
export const PAYABLES = '/payables'
export const SUPPLIER_BILLS = PAYABLES + '/supplier-bills'
export const BILLS_TO_ENTER = PAYABLES + '/bills-to-enter'
export const PO_TRACKER = PAYABLES + '/po-tracker'
export const SUPPLIER_BILL_ADD = SUPPLIER_BILLS + '/add'
export const supplierBillAddPath = (supplierId?: string, purchaseId?: string) =>
  supplierId
    ? `${SUPPLIER_BILL_ADD}?supplierId=${supplierId}${purchaseId ? `&purchaseId=${purchaseId}` : ''}`
    : SUPPLIER_BILL_ADD
export const supplierBillEditPath = (id: string) => `${SUPPLIER_BILLS}/edit/${id}`
export const supplierBillViewPath = (id: string) => `${SUPPLIER_BILLS}/view/${id}`

//Reports
export const REPORTS = '/reports'
export const REPORT_MANAGER = REPORTS + '/rpt-manager'
// The six reports of ams-reports-sample/, each its own page and permission
// (@modules/reports/reportPages.ts; ams-service qa/ams_report_menus.sql)
export const REPORT_TRIAL_BALANCE = REPORTS + '/trial-balance'
export const REPORT_BALANCE_SHEET = REPORTS + '/balance-sheet'
export const REPORT_INCOME_STATEMENT = REPORTS + '/income-statement'
export const REPORT_ACCOUNTS_LEDGER = REPORTS + '/accounts-ledger'
export const REPORT_CASH_BANK_BOOK = REPORTS + '/cash-bank-book'
export const REPORT_VOUCHER_TXN = REPORTS + '/voucher-transaction'

//settings
export const SETTINGS = '/settings'
export const COST_CENTER = SETTINGS + '/cost-center'

// Accounting setup and financial years. These strings must match auth.features.url
// exactly -- menu and route gating is string equality, so a rename here without the
// matching UPDATE in BOTH databases silently hides the screen.
export const ACC_SETUP = SETTINGS + '/acc-setup'
export const FINANCIAL_YEAR = SETTINGS + '/financial-year'
export const OPENING_BALANCE = SETTINGS + '/opening-balance'
export const GL_MAP = SETTINGS + '/gl-map'
// Account types, per company; a type's report role decides what the cash and payable /
// receivable reports count (ams-service qa/ams_acc_type_company.sql)
export const ACC_TYPE = SETTINGS + '/acc-type'
// hrm owns /settings/approval-workflow; auth.features urls are unique across apps
export const VOUCHER_APPROVAL_WORKFLOW = SETTINGS + '/voucher-approval-workflow'

// Not a route -- AMS_F_YEAR_CLOSE is a non-menu feature whose url is used purely as a
// permission key for the Close / Re-open buttons on the Financial Year screen.
export const YEAR_CLOSE = FINANCIAL_YEAR + '/close'
